module.exports = __webpack_public_path__ + "static/media/SALA-CLINICA-2.9d8f33e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clinica/SALA-CLINICA-2.png
// module id = 161
// module chunks = 0